function veda_fn_92b7f0ff0ca04407b1255b28319206da () {
        
  if (window.veda_fn_92b7f0ff0ca04407b1255b28319206daCleanup === undefined) {
    window.veda_fn_92b7f0ff0ca04407b1255b28319206daCleanup = {
      listeners: [],
      push(listener) {
        this.listeners.push(listener);
      },
      cleanup() {
        this.listeners.forEach(listener => listener());
        this.listeners = [];
      }
    }
  }
  window.veda_fn_92b7f0ff0ca04407b1255b28319206daCleanup.cleanup();

        try {
          const uniqueIds = ["id_35ad7d63-a0a7-493e-9904-aba3a39bf955","id_69e140c7-cc1f-404d-afd3-e3765256ea4f","id_0290361a-0834-44ca-baa3-799be515f1e2","id_fd78fe98-ca84-4e6e-b79f-a6506607dac7"];
          console.log({ uniqueIds });
          uniqueIds.forEach(uniqueId => {
            const containers = document.querySelectorAll(`[data-id="${uniqueId}"]`);
            containers.forEach(container => {
              if (!container) {
                return;
              }
              veda.plugins.videoCover(container);
              
            });
          });
        } catch(error) {
          console.error(error);
        }
      }
veda_fn_92b7f0ff0ca04407b1255b28319206da();
function veda_fn_841f59a48f76462a907e72a2792310be () {
      
  if (window.veda_fn_841f59a48f76462a907e72a2792310beCleanup === undefined) {
    window.veda_fn_841f59a48f76462a907e72a2792310beCleanup = {
      listeners: [],
      push(listener) {
        this.listeners.push(listener);
      },
      cleanup() {
        this.listeners.forEach(listener => listener());
        this.listeners = [];
      }
    }
  }
  window.veda_fn_841f59a48f76462a907e72a2792310beCleanup.cleanup();

      try {
        const uniqueId = "id_3c4f2264-759d-4b88-8a8b-298ad539787c";
        const containers = document.querySelectorAll(`[data-id="${uniqueId}"]`);
        containers.forEach(container => {
          if (!container) {
            return;
          }
          veda.plugins.videoCover(container);
          const { offset } = veda.utils;
const { backgroundParallax } = veda.plugins;
const videoButtonEls = container.querySelectorAll(".veda-video-button-js");
const videosEl = document.querySelector(`.veda-videos-${uniqueId}-js`);
const videoEls = videosEl.querySelectorAll(".veda-video-js");
const videoCloseEls = videosEl.querySelectorAll(
  ".veda-video-close-js, .veda-video-overlay-js"
);
const parallaxEls = container.querySelectorAll(".veda-parallax-js");

function checkPointInCircle(x, y, cx, cy, r) {
  return Math.pow(x - cx, 2) + Math.pow(y - cy, 2) <= Math.pow(r, 2);
}

if (document.querySelector(`body > .veda-videos-${uniqueId}-js`)) {
  document.querySelector(`body > .veda-videos-${uniqueId}-js`).remove();
}
document.body.appendChild(videosEl);

parallaxEls.forEach((parallaxEl) => {
  const speed = parallaxEl.getAttribute("data-parallax-speed");
  const destroy = backgroundParallax(parallaxEl, {
    speed: speed ?? 0.3,
  });
  window.veda_fn_841f59a48f76462a907e72a2792310beCleanup.push(() => {
    destroy();
  });
});
function isYoutube(url) {
  return url.search(/^https?:\/\/(www|)\.youtube\.com/g) !== -1;
}

function isVimeo(url) {
  return url.search(/^https?:\/\/(player\.|)vimeo\.com/g) !== -1;
}

videoButtonEls.forEach((videoButtonEl) => {
  const childEl = videoButtonEl.querySelector(".veda-video-button-child-js");
  let r = 150;

  function handleMouseMove(event) {
    const { top, left, width, height } = videoButtonEl.getBoundingClientRect();
    const cx = left + width / 2;
    const cy = top + height / 2;
    const lx = Math.max(cx - event.clientX, 0);
    const rx = Math.max(event.clientX - cx, 0);
    const ty = Math.max(cy - event.clientY, 0);
    const by = Math.max(event.clientY - cy, 0);
    const c = 1.3;

    if (checkPointInCircle(event.clientX, event.clientY, cx, cy, r)) {
      r = 200;
      let translateX = 0;
      let translateY = 0;
      if (lx > 0) {
        translateX = lx / -c;
      } else if (rx > 0) {
        translateX = rx / c;
      }
      if (ty > 0) {
        translateY = ty / -c;
      } else if (by > 0) {
        translateY = by / c;
      }
      childEl.style.transform = `translate(${translateX}px, ${translateY}px)`;
    } else {
      r = 150;
      childEl.style.transform = `translate(0, 0)`;
    }
  }

  function handleClick() {
    const id = videoButtonEl.getAttribute("data-button-video-id");
    const videoEl = videosEl.querySelector(`[data-video-id="${id}"`);
    if (videoEl) {
      const videoContentEl = videoEl.querySelector(".veda-video-content-js");
      const embedEl = videoEl.querySelector(".veda-embed-js");
      const src = embedEl.getAttribute("data-src");
      if (isYoutube(src) || isVimeo(src)) {
        embedEl.innerHTML = `<iframe src="${src}" frameborder="0"></iframe>`;
      } else {
        embedEl.innerHTML = `<video src="${src}" loop muted autoplay style="position: absolute;top:0;left:0;width:100%"></video>`;
      }
      videoEl.style.visibility = "visible";
      videoContentEl.style.opacity = 1;
      videoContentEl.style.transform = "scale(1)";
    }
  }

  document.addEventListener("mousemove", handleMouseMove);
  videoButtonEl.addEventListener("click", handleClick);

  window.veda_fn_841f59a48f76462a907e72a2792310beCleanup.push(() => {
    document.removeEventListener("mousemove", handleMouseMove);
    videoButtonEl.removeEventListener("click", handleClick);
  });
});

videoCloseEls.forEach((videoCloseEl) => {
  function handleClose() {
    const videoEl = videoCloseEl.closest(".veda-video-js");
    const videoContentEl = videoEl.querySelector(".veda-video-content-js");
    const embedEl = videoEl.querySelector(".veda-embed-js");
    videoEl.style.removeProperty("visibility");
    videoContentEl.style.removeProperty("opacity");
    videoContentEl.style.removeProperty("transform");
    embedEl.innerHTML = "";
  }

  videoCloseEl.addEventListener("click", handleClose);

  window.veda_fn_841f59a48f76462a907e72a2792310beCleanup.push(() => {
    videoCloseEl.removeEventListener("click", handleClose);
  });
});
        });
      } catch(error) {
        console.error(error);
      }
    }
veda_fn_841f59a48f76462a907e72a2792310be();
function veda_fn_322a5b59c8e346ed86b822af71e23a63 () {
      
  if (window.veda_fn_322a5b59c8e346ed86b822af71e23a63Cleanup === undefined) {
    window.veda_fn_322a5b59c8e346ed86b822af71e23a63Cleanup = {
      listeners: [],
      push(listener) {
        this.listeners.push(listener);
      },
      cleanup() {
        this.listeners.forEach(listener => listener());
        this.listeners = [];
      }
    }
  }
  window.veda_fn_322a5b59c8e346ed86b822af71e23a63Cleanup.cleanup();

      try {
        const uniqueId = "id_bafec62a-0f46-49fc-9b89-581c171f5593";
        const containers = document.querySelectorAll(`[data-id="${uniqueId}"]`);
        containers.forEach(container => {
          if (!container) {
            return;
          }
          veda.plugins.videoCover(container);
          const { collapse } = veda.plugins;
collapse(container, {
  activeClass: "collapse-active",
});
        });
      } catch(error) {
        console.error(error);
      }
    }
veda_fn_322a5b59c8e346ed86b822af71e23a63();
function veda_fn_34d40d64e62b4d45ab46673739aa3230 () {
      
  if (window.veda_fn_34d40d64e62b4d45ab46673739aa3230Cleanup === undefined) {
    window.veda_fn_34d40d64e62b4d45ab46673739aa3230Cleanup = {
      listeners: [],
      push(listener) {
        this.listeners.push(listener);
      },
      cleanup() {
        this.listeners.forEach(listener => listener());
        this.listeners = [];
      }
    }
  }
  window.veda_fn_34d40d64e62b4d45ab46673739aa3230Cleanup.cleanup();

      try {
        const uniqueId = "id_503af0b8-8723-4285-a830-0120af04087e";
        const containers = document.querySelectorAll(`[data-id="${uniqueId}"]`);
        containers.forEach(container => {
          if (!container) {
            return;
          }
          veda.plugins.videoCover(container);
          const { animatedSlider } = veda.plugins;

const slider = animatedSlider(container.querySelector(".veda-animated-slider"));

window.veda_fn_34d40d64e62b4d45ab46673739aa3230Cleanup.push(() => {
  slider.destroy();
});
        });
      } catch(error) {
        console.error(error);
      }
    }
veda_fn_34d40d64e62b4d45ab46673739aa3230();
function veda_fn_2aa712c0a44f46f6b3d18e0c22f32770 () {
      
  if (window.veda_fn_2aa712c0a44f46f6b3d18e0c22f32770Cleanup === undefined) {
    window.veda_fn_2aa712c0a44f46f6b3d18e0c22f32770Cleanup = {
      listeners: [],
      push(listener) {
        this.listeners.push(listener);
      },
      cleanup() {
        this.listeners.forEach(listener => listener());
        this.listeners = [];
      }
    }
  }
  window.veda_fn_2aa712c0a44f46f6b3d18e0c22f32770Cleanup.cleanup();

      try {
        const uniqueId = "id_ba15e7df-4736-4f7c-a1d1-c1ad406e7736";
        const containers = document.querySelectorAll(`[data-id="${uniqueId}"]`);
        containers.forEach(container => {
          if (!container) {
            return;
          }
          veda.plugins.videoCover(container);
          const { offset } = veda.utils;
const { backgroundParallax } = veda.plugins;
const videoButtonEls = container.querySelectorAll(".veda-video-button-js");
const videosEl = document.querySelector(`.veda-videos-${uniqueId}-js`);
const videoEls = videosEl.querySelectorAll(".veda-video-js");
const videoCloseEls = videosEl.querySelectorAll(
  ".veda-video-close-js, .veda-video-overlay-js"
);
const parallaxEls = container.querySelectorAll(".veda-parallax-js");

function checkPointInCircle(x, y, cx, cy, r) {
  return Math.pow(x - cx, 2) + Math.pow(y - cy, 2) <= Math.pow(r, 2);
}

if (document.querySelector(`body > .veda-videos-${uniqueId}-js`)) {
  document.querySelector(`body > .veda-videos-${uniqueId}-js`).remove();
}
document.body.appendChild(videosEl);

parallaxEls.forEach((parallaxEl) => {
  const speed = parallaxEl.getAttribute("data-parallax-speed");
  const destroy = backgroundParallax(parallaxEl, {
    speed: speed ?? 0.3,
  });
  window.veda_fn_2aa712c0a44f46f6b3d18e0c22f32770Cleanup.push(() => {
    destroy();
  });
});

function isYoutube(url) {
  return url.search(/^https?:\/\/(www|)\.youtube\.com/g) !== -1;
}

function isVimeo(url) {
  return url.search(/^https?:\/\/(player\.|)vimeo\.com/g) !== -1;
}

videoButtonEls.forEach((videoButtonEl) => {
  const childEl = videoButtonEl.querySelector(".veda-video-button-child-js");

  function handleMouseMove(event) {
    const { top, left, width, height } = videoButtonEl.getBoundingClientRect();
    const cx = left + width / 2;
    const cy = top + height / 2;
    const lx = Math.max(cx - event.clientX, 0);
    const rx = Math.max(event.clientX - cx, 0);
    const ty = Math.max(cy - event.clientY, 0);
    const by = Math.max(event.clientY - cy, 0);
    const r = 150;
    const c = 1.3;

    if (checkPointInCircle(event.clientX, event.clientY, cx, cy, r)) {
      let translateX = 0;
      let translateY = 0;
      if (lx > 0) {
        translateX = lx / -c;
      } else if (rx > 0) {
        translateX = rx / c;
      }
      if (ty > 0) {
        translateY = ty / -c;
      } else if (by > 0) {
        translateY = by / c;
      }
      childEl.style.transform = `translate(${translateX}px, ${translateY}px)`;
    } else {
      childEl.style.transform = `translate(0, 0)`;
    }
  }

  function handleClick() {
    const id = videoButtonEl.getAttribute("data-button-video-id");
    const videoEl = videosEl.querySelector(`[data-video-id="${id}"`);
    if (videoEl) {
      const videoContentEl = videoEl.querySelector(".veda-video-content-js");
      const embedEl = videoEl.querySelector(".veda-embed-js");
      const src = embedEl.getAttribute("data-src");
      if (isYoutube(src) || isVimeo(src)) {
        embedEl.innerHTML = `<iframe src="${src}" frameborder="0"></iframe>`;
      } else {
        embedEl.innerHTML = `<video src="${src}" loop muted autoplay style="position: absolute;top:0;left:0;width:100%"></video>`;
      }
      videoEl.style.visibility = "visible";
      videoContentEl.style.opacity = 1;
      videoContentEl.style.transform = "scale(1)";
    }
  }

  document.addEventListener("mousemove", handleMouseMove);
  videoButtonEl.addEventListener("click", handleClick);

  window.veda_fn_2aa712c0a44f46f6b3d18e0c22f32770Cleanup.push(() => {
    document.removeEventListener("mousemove", handleMouseMove);
    videoButtonEl.removeEventListener("click", handleClick);
  });
});

videoCloseEls.forEach((videoCloseEl) => {
  function handleClose() {
    const videoEl = videoCloseEl.closest(".veda-video-js");
    const videoContentEl = videoEl.querySelector(".veda-video-content-js");
    const embedEl = videoEl.querySelector(".veda-embed-js");
    videoEl.style.removeProperty("visibility");
    videoContentEl.style.removeProperty("opacity");
    videoContentEl.style.removeProperty("transform");
    embedEl.innerHTML = "";
  }

  videoCloseEl.addEventListener("click", handleClose);

  window.veda_fn_2aa712c0a44f46f6b3d18e0c22f32770Cleanup.push(() => {
    videoCloseEl.removeEventListener("click", handleClose);
  });
});
        });
      } catch(error) {
        console.error(error);
      }
    }
veda_fn_2aa712c0a44f46f6b3d18e0c22f32770();
function veda_fn_a69bbc81c1f04834bf8af2749e15a411 () {
      
  if (window.veda_fn_a69bbc81c1f04834bf8af2749e15a411Cleanup === undefined) {
    window.veda_fn_a69bbc81c1f04834bf8af2749e15a411Cleanup = {
      listeners: [],
      push(listener) {
        this.listeners.push(listener);
      },
      cleanup() {
        this.listeners.forEach(listener => listener());
        this.listeners = [];
      }
    }
  }
  window.veda_fn_a69bbc81c1f04834bf8af2749e15a411Cleanup.cleanup();

      try {
        const uniqueId = "id_1a559adb-9f2f-4afc-9d09-ad29382fb132";
        const containers = document.querySelectorAll(`[data-id="${uniqueId}"]`);
        containers.forEach(container => {
          if (!container) {
            return;
          }
          veda.plugins.videoCover(container);
          const {
  message,
  productCompare,
  productWishList,
  productQuickView,
  productColor,
  cart,
} = veda.plugins;
const { objectParse, imageUrl, getObjectAttributes } = veda.utils;
let loading = false;

function checkHasItem(productData, storeData) {
  return storeData?.some((item) => item.id === productData.id);
}

let iconType = "";
function changeStatus(el, hasItem) {
  if (!el) {
    return;
  }
  /** @type HTMLElement */
  const iconEl = el.querySelector('i[class^="fa"]');
  if (!iconType) {
    iconType = Array.from(iconEl.classList).find((className) =>
      /fa\w/g.test(className)
    );
  }
  if (hasItem()) {
    el.setAttribute("data-tooltip-active", true);
    el.style.setProperty("color", "var(--color-primary)", "important");
    if (iconType.includes("fa")) {
      iconEl.classList.remove(iconType);
      iconEl.classList.add("fas");
    }
  } else {
    el.setAttribute("data-tooltip-active", false);
    el.style.removeProperty("color");
    if (iconType.includes("fa")) {
      iconEl.classList.remove("fas");
      iconEl.classList.add(iconType);
    }
  }
  return hasItem;
}

function handleCompare() {
  const listCard = container.querySelectorAll(".product-card-js");
  listCard.forEach((card) => {
    const compareDataEl = card.querySelector(".product-card-data-js");
    const productData = objectParse(compareDataEl.textContent);
    const btnCompareEl = card.querySelector(".compare-toggle-js");
    const ratingCustom = card.querySelector(".compare-rating-js");
    if (!btnCompareEl) {
      return;
    }
    const hasItem = () => checkHasItem(productData, productCompare.getData());
    changeStatus(btnCompareEl, hasItem);
    const handleClick = () => {
      productCompare.toggleProduct({
        ...productData,
        rating: ratingCustom?.innerHTML,
      });
      const tooltipText = btnCompareEl.getAttribute("data-tooltip-text");
      const tooltipActiveText = btnCompareEl.getAttribute(
        "data-tooltip-active-text"
      );
      changeStatus(btnCompareEl, hasItem);
      if (hasItem()) {
        tooltipText && message.success(tooltipText);
      } else {
        tooltipActiveText && message.error(tooltipActiveText);
      }
    };
    btnCompareEl.addEventListener("click", handleClick);
    window.veda_fn_a69bbc81c1f04834bf8af2749e15a411Cleanup.push(() => {
      btnCompareEl.removeEventListener("click", handleClick);
    });
  });
  let unsubscribeCompare = productCompare.subscribe((state) => {
    const listCard = container.querySelectorAll(".product-card-js");
    listCard.forEach((card) => {
      const compareDataEl = card.querySelector(".product-card-data-js");
      const productData = objectParse(compareDataEl.textContent);
      const btnCompareEl = card.querySelector(".compare-toggle-js");
      const hasItem = () => checkHasItem(productData, state);
      changeStatus(btnCompareEl, hasItem);
    });
  });
  window.veda_fn_a69bbc81c1f04834bf8af2749e15a411Cleanup.push(() => {
    unsubscribeCompare();
  });
}

function handleWishList() {
  const listCard = container.querySelectorAll(".product-card-js");
  listCard.forEach((card) => {
    const compareDataEl = card.querySelector(".product-card-data-js");
    const productData = objectParse(compareDataEl.textContent);
    const btnWishListEl = card.querySelector(".wishlist-toggle-js");
    if (!btnWishListEl) {
      return;
    }
    const hasItem = () => checkHasItem(productData, productWishList.getData());
    changeStatus(btnWishListEl, hasItem);
    const handleClick = () => {
      productWishList.toggleWishList(productData);
      const tooltipText = btnWishListEl.getAttribute("data-tooltip-text");
      const tooltipActiveText = btnWishListEl.getAttribute(
        "data-tooltip-active-text"
      );
      changeStatus(btnWishListEl, hasItem);
      if (hasItem()) {
        tooltipText && message.success(tooltipText);
      } else {
        tooltipActiveText && message.error(tooltipActiveText);
      }
    };
    btnWishListEl.addEventListener("click", handleClick);
    window.veda_fn_a69bbc81c1f04834bf8af2749e15a411Cleanup.push(() => {
      btnWishListEl.removeEventListener("click", handleClick);
    });
  });
  let unsubscribeWishList = productWishList.subscribe((state) => {
    const listCard = container.querySelectorAll(".product-card-js");
    listCard.forEach((card) => {
      const dataEl = card.querySelector(".product-card-data-js");
      const productData = objectParse(dataEl.textContent);
      const btnWishList = card.querySelector(".wishlist-toggle-js");
      const hasItem = () => checkHasItem(productData, state);
      changeStatus(btnWishList, hasItem);
    });
  });
  window.veda_fn_a69bbc81c1f04834bf8af2749e15a411Cleanup.push(() => {
    unsubscribeWishList();
  });
}

function addCartSuccess(el) {
  const check = `
      <svg class="checkmark w:14px h:14px mr:10px@md bdrs:50% d:block stkw:2 stk:#fff stroke-miterlimit:10 bxsh:inset_0px_0px_0px_#7ac142 anim:fill_0.4s_ease-in-out_0.4s_forwards,scale_0.3s_ease-in-out_0.9s_both" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
        <circle class='checkmark__circle sd:166 stroke-dasharray:166 stkw:2 stroke-miterlimit:10 stk:#7ac142 fill:none anim:stroke_0.6s_cubic-bezier(0.65,0,0.45,1)_forwards' cx='26' cy='26' r='25' fill='none'/> 
        <path class='checkmark__check trfo:50%_50% stroke-dasharray:48 sd::48 anim:stroke_0.3s_cubic-bezier(0.65,0,0.45,1)_0.8s_forwards' fill='none' d='M14.1 27.2l7.1 7.2 16.7-16.8'/>
      </svg>`;
  el.insertAdjacentHTML("afterbegin", check);
  const id = setTimeout(() => {
    const checkEl = el.querySelector(".checkmark");
    const iconEl = el.querySelector(".product-cart-add-icon-js");
    if (!!checkEl) {
      checkEl.remove();
      iconEl?.style?.removeProperty("display");
    }
    loading = false;
    clearTimeout(id);
  }, 2000);
  window.veda_fn_a69bbc81c1f04834bf8af2749e15a411Cleanup.push(() => {
    clearTimeout(id);
  });
}

function handleCart() {
  const listCard = container.querySelectorAll(".product-card-js");
  listCard.forEach((card) => {
    const btnAddCartEls = card.querySelectorAll(".product-card-add-js");
    if (!btnAddCartEls) {
      return;
    }
    btnAddCartEls.forEach((btnAddCartEl) => {
      const iconEl = btnAddCartEl.querySelector(".product-cart-add-icon-js");
      const currentVariantIdEl = btnAddCartEl
        .closest(".product-card-js")
        .querySelector(".current-variant-id");
      const handleClick = async (event) => {
        event.preventDefault();
        if (!loading) {
          loading = true;
          const spinner =
            "<div class='veda-spinner bdw:2px mr:10px@md' style='--spinner-color: var(--color-light-freeze); --spinner-size: 14px'></div>";
          btnAddCartEl.insertAdjacentHTML("afterbegin", spinner);
          if (iconEl) {
            iconEl.style.display = "none";
          }
          if (builderMode) {
            const id = setTimeout(() => {
              const currentSpinner =
                btnAddCartEl.querySelector(".veda-spinner");
              currentSpinner.remove();
              addCartSuccess(btnAddCartEl);
              clearTimeout(id);
            }, 2000);
            window.veda_fn_a69bbc81c1f04834bf8af2749e15a411Cleanup.push(() => {
              clearTimeout(id);
            });
          } else {
            cart
              .addToCart(Number(currentVariantIdEl.textContent.trim()), 1)
              .then(() => {
                const currentSpinner =
                  btnAddCartEl.querySelector(".veda-spinner");
                currentSpinner.remove();
                addCartSuccess(btnAddCartEl);
              })
              .catch((err) => {
                const currentSpinner =
                  btnAddCartEl.querySelector(".veda-spinner");
                currentSpinner.remove();
                loading = false;
                message.error(err.toString());
              });
          }
        }
      };
      btnAddCartEl.addEventListener("click", handleClick);
      window.veda_fn_a69bbc81c1f04834bf8af2749e15a411Cleanup.push(() => {
        btnAddCartEl.removeEventListener("click", handleClick);
      });
    });
  });
}

function handleQuickView() {
  const listCard = container.querySelectorAll(".product-card-js");
  const quickViewDataEl = container.querySelector(".quickview-data-js");
  if (!!quickViewDataEl) {
    const quickViewData = objectParse(quickViewDataEl.textContent);
    productQuickView.customQuickView(quickViewData);
  }
  listCard.forEach((card) => {
    const cartDataEl = card.querySelector(".product-card-data-js");
    const productData = objectParse(cartDataEl.textContent);
    const btnQuickViewEls = card.querySelectorAll(".quickview-toggle-js");
    if (!btnQuickViewEls) {
      return;
    }
    btnQuickViewEls.forEach((btnQuickViewEl) => {
      const handleClick = () => {
        productQuickView.togglePopup({
          ...productData,
        });
      };
      btnQuickViewEl.addEventListener("click", handleClick);
      window.veda_fn_a69bbc81c1f04834bf8af2749e15a411Cleanup.push(() => {
        btnQuickViewEl.removeEventListener("click", handleClick);
      });
    });
  });
}

function handleColor() {
  const listCard = container.querySelectorAll(".product-card-js");
  productColor.init({
    onChange: (_color, image, currentEl, _, variant) => {
      const currentPriceEl = currentEl
        .closest(".product-card-js")
        ?.querySelector(".product-content-price-js");
      const currentVariantIdEl = currentEl
        .closest(".product-card-js")
        ?.querySelector(".current-variant-id");
      const soldOutEl = currentEl
        .closest(".product-card-js")
        ?.querySelector(".sold-out-js");
      if (!!currentVariantIdEl) {
        currentVariantIdEl.textContent = variant.id;
      }
      if (!!currentPriceEl) {
        const onSaleEl = currentPriceEl.querySelector(
          ".product-price-on-sale-js"
        );
        const notSaleEl = currentPriceEl.querySelector(
          ".product-price-not-sale-js"
        );
        if (variant.compare_at_price > variant.price) {
          const regularPrice = onSaleEl.querySelector("ins");
          const salePrice = onSaleEl.querySelector("del");
          onSaleEl.classList.remove("d:none");
          if (!notSaleEl.classList.contains("d:none")) {
            notSaleEl.classList.add("d:none");
          }
          regularPrice.innerHTML = variant.price;
          salePrice.innerHTML = variant.compare_at_price;
        } else {
          notSaleEl.classList.remove("d:none");
          if (!onSaleEl.classList.contains("d:none")) {
            onSaleEl.classList.add("d:none");
          }
          notSaleEl.innerHTML = variant.price;
        }
      }
      if (!!soldOutEl) {
        if (!variant.available) {
          soldOutEl.style.display = "block";
        } else {
          soldOutEl.style.display = "none";
        }
      }
      const currentImage = currentEl
        .closest(".product-card-js")
        ?.querySelector(".product-card-image-js");
      currentImage.src = imageUrl(image, 10);
    },
    onMouseEnter: (event) => {
      const currentImage = event.target
        .closest(".product-card-js")
        ?.querySelector(".product-card-image-js");
      if (!!currentImage) {
        currentImage.parentNode.style.setProperty("opacity", "1");
        currentImage.parentNode.nextElementSibling?.style?.setProperty(
          "opacity",
          "0"
        );
        currentImage.parentNode.nextElementSibling?.style?.setProperty(
          "left",
          "-10000px"
        );
      }
    },
    onMouseLeave: (event) => {
      const currentImage = event.target
        .closest(".product-card-js")
        ?.querySelector(".product-card-image-js");
      if (!!currentImage) {
        currentImage.parentNode.style.removeProperty("opacity");
        currentImage.parentNode.nextElementSibling?.style.removeProperty(
          "opacity"
        );
        currentImage.parentNode.nextElementSibling?.style.removeProperty(
          "left"
        );
      }
    },
  });
  listCard.forEach((card) => {
    const cartDataEl = card.querySelector(".product-card-data-js");
    const productData = objectParse(cartDataEl.textContent);
    const colorWrapper = card.querySelector(".product-card-colors-js");
    if (!colorWrapper) {
      return;
    }
    productColor.render(colorWrapper, productData);
  });
}

handleCompare();
handleWishList();
handleQuickView();
handleCart();
handleColor();
        });
      } catch(error) {
        console.error(error);
      }
    }
veda_fn_a69bbc81c1f04834bf8af2749e15a411();
function veda_fn_9d05625e9cbe498c94ef643737b6f1b5 () {
      
  if (window.veda_fn_9d05625e9cbe498c94ef643737b6f1b5Cleanup === undefined) {
    window.veda_fn_9d05625e9cbe498c94ef643737b6f1b5Cleanup = {
      listeners: [],
      push(listener) {
        this.listeners.push(listener);
      },
      cleanup() {
        this.listeners.forEach(listener => listener());
        this.listeners = [];
      }
    }
  }
  window.veda_fn_9d05625e9cbe498c94ef643737b6f1b5Cleanup.cleanup();

      try {
        const uniqueId = "id_cf46d3ae-4e7e-402f-ba27-044794b8023f";
        const containers = document.querySelectorAll(`[data-id="${uniqueId}"]`);
        containers.forEach(container => {
          if (!container) {
            return;
          }
          veda.plugins.videoCover(container);
          const instance = veda.plugins.swiper(container);
window.veda_fn_9d05625e9cbe498c94ef643737b6f1b5Cleanup.push(() => {
  instance.destroy();
})
        });
      } catch(error) {
        console.error(error);
      }
    }
veda_fn_9d05625e9cbe498c94ef643737b6f1b5();